/**
 * User role constants — must stay in sync with server/utils/roles.js
 */

export const ROLES = Object.freeze({
  MANAGER: 'Manager',
  EMPLOYEE: 'Employee',
  CLIENT: 'Client',
});
